<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-body">
      @if(selectionType === ScheduleTimeSelectionType.TIME_PICKER){
      <div class="date-time-picker">
        <input
          class="form-control flatpickr-input d-none"
          type="text"
          mwlFlatpickr
          [altInput]="true"
          [enableTime]="true"
          [convertModelValue]="true"
          [altFormat]="'F j, Y h:i K'"
          [dateFormat]="'Y-m-d H:i'"
          [inline]="true"
          [defaultValue]="defaultDateString"
          [minDate]="minDate"
          [maxDate]="maxDate"
          (flatpickrReady)="onFlatpickrReady($event)"
          (change)="onDateChange($event)"
        />
      </div>
      } @else if((selectionType === ScheduleTimeSelectionType.SLOT || selectionType === ScheduleTimeSelectionType.SLOT_RANGE) && !isDateSelected){
      <div class="date-time-picker">
        <input
          class="form-control flatpickr-input d-none"
          type="text"
          mwlFlatpickr
          [altInput]="true"
          [convertModelValue]="true"
          [altFormat]="'F j, Y h:i K'"
          [dateFormat]="'Y-m-d H:i'"
          [inline]="true"
          [defaultValue]="defaultDateString"
          [minDate]="minDate"
          [maxDate]="maxDate"
          (flatpickrReady)="onFlatpickrReady($event)"
          (change)="onDateChange($event)"
        />
      </div>
      }

      <!-- Time slot selection stage -->
      @if((selectionType === ScheduleTimeSelectionType.SLOT || selectionType === ScheduleTimeSelectionType.SLOT_RANGE) && isDateSelected){
      <div>
        <h4>{{ selectionType === ScheduleTimeSelectionType.SLOT ? ("heading-title.select-time-slot" | translate) : ("heading-title.select-time-slot-range" | translate) }}</h4>
        <div class="slot-buttons">
          @if(selectionType === ScheduleTimeSelectionType.SLOT_RANGE){ @for(slotRange of slotRanges; track $index){
          <button class="btn btn-outline-primary w-100 mb-1" [class.active]="selectedSlotRange === slotRange" (click)="selectSlotRange(slotRange)">
            {{ slotRange }}
          </button>
          } } @if(selectionType === ScheduleTimeSelectionType.SLOT){ @for(slot of timeSlots; track $index){
          <button class="btn btn-outline-primary w-100 mb-1" [class.active]="selectedSlot === slot" (click)="selectSlot(slot)">
            {{ slot }}</button
          >} }
        </div>
      </div>
      }

      <div class="row mt-4">
        <div class="col-sm-6 mb-sm-0 mb-2">
          <button type="button" class="btn btn-secondary w-100" (click)="selectDate()">
            {{ "button-title.select" | translate }}
          </button>
        </div>

        <div class="col-sm-6">
          <button type="button" class="btn btn-outline-primary waves-effect waves-light material-shadow-none w-100" (click)="closeModal()">
            {{ "button-title.cancel" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
